require('./brokerStocksBuyStep2.scss');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');

// @ commons
const { OKMessage } = require('commonsComponents/OKMessage');

// @ components
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const { ConfirmationScript, CONFIRMATION_SCRIPT_GREETING, CONFIRMATION_SCRIPT_AGREEMENT } = require('components/contactCenter/confirmScript/confirmationScript');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const { LoadingSection } = require('commonsComponents/loadingSection');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const ShowExtantCost = require('components/broker/brokerStocksBuy/brokerStocksBuyStep2/components/showExtantCost/showExtantCost')

// @ actions
const BrokerMiFIDProductsAction = require('mifid/actions/brokerMiFIDProducts');
const BrokerStocksBuyActions = require('actions/brokerStocksBuy');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const { getFormattedString, formatAmount, formatCurrency } = require('utilities/currencyHelper');
const { getInstitutionDescOfMarket } = require('utilities/micCodeHelper');

// @ constants
const {
    CHARGE_ACCOUNT_PREFIX,
    FIRST_STEP,
    BROKER_ORDER_TYPE_FOR_THE_BEST,
    BROKER_ORDER_TYPE_TO_MARKET,
    BROKER_ORDER_TYPE_LIMITED,
    BROKER_CONVENIENCE_MIFID_TEST_STOCKS_ID,
    BROKER_TYPE_STOCKS_NEW_DECIMALS,
    BROKER_MIFID_VERSION_1
} = require('constants/index');

const {
    STOCKS_BUY_SHOW_PROFITABILITY,
} = require('constants/flagBasedFeatures');

const { BROKER_STOCKS_BUY_ID } = require('constants/operationTypes');

class BrokerStocksBuyStep2 extends React.Component {
    constructor(props) {
        super(props);

        this.buildMiFIDDisclaimer = this.buildMiFIDDisclaimer.bind(this);
    }

    componentDidMount() {
        const { immBrokerConvenienceMiFIDTest } = this.props;
        const usingMifidv1 = immBrokerConvenienceMiFIDTest.get('mifidVersion') === BROKER_MIFID_VERSION_1;

        if (usingMifidv1) {
            const productId = BROKER_CONVENIENCE_MIFID_TEST_STOCKS_ID;
            this.props.onFetchBrokerMiFIDProduct(productId);
        }
    }

    getOrderType(orderType) {
        if (orderType === BROKER_ORDER_TYPE_TO_MARKET) {
            return formatText('broker-stocksBuyStep1ToMarketLabel');
        } else if (orderType === BROKER_ORDER_TYPE_FOR_THE_BEST) {
            return formatText('broker-stocksBuyStep1ForTheBestLabel');
        } else {
            return formatText('broker-stocksBuyStep1LimitedLabel');
        }
    }

    buildMiFIDDisclaimer() {
        const { immBrokerConvenienceMiFIDTest, immBrokerMiFIDProducts } = this.props;
        const usingMifidv1 = immBrokerConvenienceMiFIDTest.get('mifidVersion') === BROKER_MIFID_VERSION_1;

        let mifidDisclaimer;

        if (usingMifidv1) {
            const mifidProductsLoading = immBrokerMiFIDProducts.getIn([
                'products',
                BROKER_CONVENIENCE_MIFID_TEST_STOCKS_ID,
                'loading'
            ]);

            if (mifidProductsLoading) {
                mifidDisclaimer = <LoadingSection />;
            } else {
                mifidDisclaimer = immBrokerMiFIDProducts.getIn([
                    'products',
                    BROKER_CONVENIENCE_MIFID_TEST_STOCKS_ID,
                    'disclaimer'
                ]);
            }

            return (
                <section className="stocks-buy-step2__clause-section row">
                    <div className="col-lg-12">
                        <h2 className="stocks-buy-step2__clause-section-title">
                            <FormattedText value="broker-stocksBuyStep2ClauseSectionLabel"/>
                        </h2>
                        <section className="stocks-buy-step2__clause-section-info-container">
                            <p className="stocks-buy-step2__clause-section-info">
                                {mifidDisclaimer}
                            </p>
                        </section>
                    </div>
                </section>
            );
        }
    }

    buildDisclaimerITF(PREFIX, hasITF) {
        let content;
        if (hasITF) {
            const disclaimerITFParagraph1 = formatText(`${PREFIX}DisclaimerParagraph1`);
            const disclaimerITFParagraph2 = formatText(`${PREFIX}DisclaimerParagraph2`);
            const disclaimerITFParagraph3 = formatText(`${PREFIX}DisclaimerParagraph3`);
            content = (
                <React.Fragment>
                    <div className="stocks-buy-step2__disclaimer">
                        <OKMessage
                            id="stocks-buy-step2-disclaimer"
                            type="informative"
                            visible={true}
    >
                            {disclaimerITFParagraph1}
                            {disclaimerITFParagraph2}
                            <div>{disclaimerITFParagraph3}</div>
                        </OKMessage>
                    </div>
                    <ContactCenterRender>
                        <div className="stocks-buy-step2__disclaimer">
                            <BlockInfo>
                                <FormattedText
                                    className="stocks-buy-step2__disclaimer-title"
                                    value="broker-stocksBuyStep2DisclaimerITFTitle"
                                />
                                <FormattedText
                                    value="broker-stocksBuyStep2DisclaimerITFDescription"
                                />
                            </BlockInfo>
                        </div>
                    </ContactCenterRender>
                </React.Fragment>
            );
        }
        else {
            const disclaimerParagraph1 = formatText(`${PREFIX}DisclaimerParagraph1`);
            const disclaimerParagraph2 = formatText(`${PREFIX}DisclaimerParagraph2`);
            content = (
                <div className="stocks-buy-step2__disclaimer">
                    <OKMessage
                        id="stocks-buy-step2-disclaimer"
                        type="informative"
                        visible={true}
                                >
                        {disclaimerParagraph1}
                        {disclaimerParagraph2}
                    </OKMessage>
                </div>
            );
        }
        return content;
    }

    buildOrderTypeSection() {
        const { immStocksBuy, productFile } = this.props;
        const orderType = immStocksBuy.getIn(['steps', FIRST_STEP, 'orderType']);
        const orderTypeLabel = formatText('broker-stocksBuySellSummaryStockTypeTitle');

        let result;

        if (orderType === BROKER_ORDER_TYPE_LIMITED) {
            const amount = immStocksBuy.getIn(['steps', FIRST_STEP, 'orderTypeLimited']);
            const currency = productFile.get('currency');
            const amountFormatted = getFormattedString({
                amount,
                currency,
                decimalsLength: BROKER_TYPE_STOCKS_NEW_DECIMALS
            });
            const limitedText = formatText('broker-stocksBuySellSummaryLimitedStockValue');
            const formatedTextAmount = `${limitedText} (${amountFormatted})`;

            result = (
                <OKInformativeListItem
                    title={orderTypeLabel}
                    bodyText={formatedTextAmount}
                    isUppercaseTitle={true}
                />
            );
        } else {
            const orderTypeText = this.getOrderType(orderType);

            result = (
                <OKInformativeListItem
                    title={orderTypeLabel}
                    bodyText={orderTypeText}
                    isUppercaseTitle={true}
                />
            );
        }

        return result;
    }

    render() {
        const PREFIX = 'broker-stocksBuyStep2';

        const headerTitle = formatText(`${PREFIX}HeaderTitle`);
        const headerInfo = formatText(`${PREFIX}HeaderInfo`);
        const stockTitleLabel = formatText(`${PREFIX}StockTitleLabel`);
        const contractTitleLabel = formatText(`${PREFIX}ContractTitleLabel`);
        const firstOwnerLabel = formatText(`${PREFIX}FirstOwnerLabel`);
        const associateAccountLabel = formatText(`${PREFIX}AssociateAccountLabel`);
        const balanceLabel = formatText(`${PREFIX}BalanceLabel`);
        const titlesLabel = formatText(`${PREFIX}TitlesLabel`);
        const validityLabel = formatText(`${PREFIX}ValidityLabel`);

        const { immStocksBuy, productFile, immFeatureFlags, step1, fetchExtantCostDetails } = this.props;
        const showExtantCost = immFeatureFlags.get('wealth_stocks_buy_show_costs')
        const micCode = productFile.get('micCode');
        const marketInfo = getInstitutionDescOfMarket(micCode);
        const stockName = productFile.get('companyName');
        const dateFormat = formatText('broker-stocksLikeHeaderDateFormat');
        const validityDate = immStocksBuy
            .getIn(['steps', FIRST_STEP, 'validityDate'])
            .format(dateFormat);
        const selectedOption = immStocksBuy.getIn([
            'steps',
            FIRST_STEP,
            'stocksContractSelectedValue'
        ]);
        const selectedAccount = this.props.immStocksContracts.get(selectedOption);
        const contractNumber = selectedAccount.get('walletNumber');
        const productNumber = selectedAccount.get('productNumber');
        const controlDigit = selectedAccount.get('controlDigit');
        const accountNumber = selectedAccount.get('associatedAccount');
        const walletAccountType = selectedAccount.get('walletAccountType');
        const walletBalance = selectedAccount.getIn(['associatedAccountBalance', 'amount']);
        const walletCurrency = selectedAccount.getIn(['associatedAccountBalance', 'currency']);
        const accountOwner = selectedAccount.get('firstTitular');
        const accountName = selectedAccount.get('associatedAccountAlias');
        const chargeAccount = `${CHARGE_ACCOUNT_PREFIX}${productNumber}${contractNumber}`;
        const titlesAmount = immStocksBuy.get('confirmationData').titulosImporteAproximado;
        const operationParams = {
            bondsNumber: titlesAmount,
            chargeAccount: chargeAccount
        };
        const operative = formatText('operatives-stocksBuy');
        const orderTypeSection = this.buildOrderTypeSection();
        const disclaimerITF = this.buildDisclaimerITF(PREFIX, productFile.get('itf') );
        const showProfitabilitySection = immFeatureFlags.get(STOCKS_BUY_SHOW_PROFITABILITY);

        return (
            <div className="stocks-buy-step2">
                <header className="stocks-buy-step2__header row">
                    <div className="col-lg-12">
                        <h2 className="stocks-buy-step2__header-title">
                            {headerTitle}
                        </h2>
                        <ContactCenterRender>
                            <ConfirmationScript operative={operative} confirmationType={CONFIRMATION_SCRIPT_GREETING} />
                        </ContactCenterRender>
                        <p className="stocks-buy-step2__header-info">
                            {headerInfo}
                        </p>
                    </div>
                </header>

                {showExtantCost ? (
                    <ShowExtantCost
                        immStocksBuy={immStocksBuy}
                        productFile={productFile}
                        step1={step1}
                        immStocksContracts={this.props.immStocksContracts}
                        fetchExtantCostDetails={fetchExtantCostDetails}
                        showProfitabilitySection={showProfitabilitySection}
                    />
                ) : (
                    <section className="stocks-buy-step2__info-section row">
                        <div className="col-lg-4">
                            <OKInformativeList>
                                <OKInformativeListItem
                                    title={stockTitleLabel.toUpperCase()}
                                    bodyText={stockName}
                                    columns={1}
                                >
                                    <span className="stocks-buy-step2__stock-info">
                                        {marketInfo}
                                    </span>
                                </OKInformativeListItem>

                                <OKInformativeListItem
                                    title={contractTitleLabel.toUpperCase()}
                                    bodyText={walletAccountType}
                                    columns={1}
                                >
                                    <div className="stocks-buy-step2__contract-values-info stocks-buy-step2__contract-values-info--account">
                                        {CHARGE_ACCOUNT_PREFIX}
                                        {controlDigit}
                                        {productNumber}
                                        {contractNumber}
                                    </div>

                                    <div className="stocks-buy-step2__contract-values-info">
                                        {firstOwnerLabel}: {accountOwner}
                                    </div>
                                    <div className="stocks-buy-step2__contract-values-info">
                                        {associateAccountLabel}: {accountName}
                                    </div>
                                    <div className="stocks-buy-step2__contract-values-info">
                                        {accountNumber} ({balanceLabel}: {formatAmount(walletBalance)}{' '}
                                        {formatCurrency(walletCurrency)})
                                    </div>
                                </OKInformativeListItem>
                            </OKInformativeList>
                        </div>

                        <div className="col-lg-3 col-lg-offset-1">
                            <div className="stocks-buy-step2__titles-container">
                                <OKInformativeList>
                                    <OKInformativeListItem
                                        title={titlesLabel.toUpperCase()}
                                        bodyText={`${titlesAmount} ${titlesLabel}`}
                                    />
                                    {orderTypeSection}
                                    <OKInformativeListItem
                                        title={validityLabel.toUpperCase()}
                                        bodyText={validityDate.toString()}
                                    />
                                </OKInformativeList>
                            </div>
                        </div>
                    </section>
                    )
                }

                {this.buildMiFIDDisclaimer()}
                <footer className="stocks-buy-step2__footer row">
                    <div className="col-lg-12">
                        {disclaimerITF}
                    </div>
                </footer>
                <section className="stocks-buy-step2__signature-pattern-section">
                    <ContactCenterRender>
                        <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                    </ContactCenterRender>
                    <div className="stocks-buy-step2_otp-section">
                        <SignaturePattern
                            operationType={BROKER_STOCKS_BUY_ID}
                            operationParams={operationParams}
                        />
                    </div>
                </section>
            </div>
        );
    }
}

BrokerStocksBuyStep2.propTypes = {
    immStocksBuy: PropTypes.object,
    productFile: PropTypes.object,
    immStocksContracts: PropTypes.object,
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired,
    immBrokerMiFIDProducts: PropTypes.object.isRequired,
    onFetchBrokerMiFIDProduct: PropTypes.func.isRequired,
    step1: PropTypes.object.isRequired,
    immFeatureFlags: PropTypes.object.isRequired,
    fetchExtantCostDetails: PropTypes.func.isRequired,
};

module.exports.constructor = BrokerStocksBuyStep2;
module.exports.BrokerStocksBuyStep2 = connect(
    state => ({
        immStocksBuy: state.brokerStocksBuy,
        immBrokerConvenienceMiFIDTest: state.brokerConvenienceMiFIDTest,
        immBrokerMiFIDProducts: state.brokerMiFIDProducts
    }),
    {
        onFetchBrokerMiFIDProduct: BrokerMiFIDProductsAction.fetchMiFIDProduct,
        fetchExtantCostDetails: BrokerStocksBuyActions.getExtantCostDetails
    }
)(BrokerStocksBuyStep2);
